import * as components from '../../../components'
import * as ReactBootstrap from 'react-bootstrap'
import React from 'react'
import Attachment from './Attachment'
import {TicketPrint, UploadContent} from "../../../api";

export type AttachmentListProps={
  ticket:TicketPrint & {uploaded_contents:Array<UploadContent>}
  onTicketUpdate:(ticket:TicketPrint)=>void
}
const AttachmentList = ({ ticket, onTicketUpdate }:AttachmentListProps) => {
  const { uploaded_contents } = ticket
  return (
    <>
      {uploaded_contents.length ? (
        <components.ItemList
          itemRenderer={(index:number, key:string) => {
            return (
              <div key={uploaded_contents[index].url}>
                <Attachment
                  ticket={ticket}
                  document={uploaded_contents[index]}
                  onTicketUpdate={onTicketUpdate}
                />
              </div>
            )
          }}
          length={uploaded_contents.length}
        />
      ) : (
        <ReactBootstrap.Alert variant={'info'}>
          No previous Attachments found.
        </ReactBootstrap.Alert>
      )}
    </>
  )
}

export default AttachmentList
